/*
 * @Date: 2023-07-24 15:35:38
 * @LastEditors: chuhongguang
 */

// 顶部导航
export const navList = [
  {
    title: '首页',
    name: 'home',
    path: '/home'
  },
  {
    title: 'GPT实验室',
    name: '11',
    path: '/gptLaboratory'
  }, {
    title: '策略库',
    name: '7',
    path: '/policyLibrary'
  }
]



// WEBPACK FOOTER //
// ./src/components/Mobile/Nav/controller/options.js